export default __webpack_public_path__ + "static/media/Blade's Tunic of the Battlethrall.d91a1c7d.jpg";